// extracted by mini-css-extract-plugin
export var descriptionContainer = "UnderskinQuestion_descriptionContainer__U8qic";
export var imageContainer = "UnderskinQuestion_imageContainer__9h8qZ";
export var md = "768px";
export var shared = "'../../../../shared.module.css'";
export var underskinColorQuestionContainer = "UnderskinQuestion_underskinColorQuestionContainer__LeJ7z";